import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";
import { createPopper } from "@popperjs/core";

const initializePlugins = () => {
  Alpine.plugin(collapse);
}

const initializeData = () => {
  Alpine.data("popperable", (variableName) => ({
    popperInstance: null,

    init(attributeName = variableName === "nil" ? "open" : variableName, refElement = null) {
      if (this.$el.dataset.elementSelector)
        refElement = document.querySelector(this.$el.dataset.elementSelector);
      if (!refElement)
        refElement = this.$el.parentElement;

      this.popperInstance = createPopper(refElement, this.$el, { placement: this.$el.dataset.placement || "bottom-start" });
      this.$watch(attributeName, (shown) => { this.handleShownState(shown); });
    },

    handleShownState(shown) {
      this.$nextTick(() => { this.popperInstance.update(); });

      // Enable/disable popper event listeners when shown/hidden.
      this.popperInstance.setOptions((options) => ({
        ...options,
        modifiers: [
          ...options.modifiers,
          { name: 'eventListeners', enabled: shown },
        ],
      }));
    },
  }));

  Alpine.data("modalToggleable", (modalId) => ({
    handleModalToggle(e) {
      if (!e.detail[modalId]) return;

      this[modalId] = e.detail[modalId];
    }
  }));
}

export const initializeAlpine = () => {
  initializePlugins();
  initializeData();

  Alpine.start();
}
